import React from 'react';
import { chromeString } from '../../helpers/questionnaire_translations';

/**
 * Provides the selected locale, translation blob, an interface-chrome resolver,
 * and an optional language-switcher node to the shared questionnaire
 * components. The default value renders everything in English with no switcher,
 * so the many legacy flows that mount QuestionWrapper without a provider are
 * unaffected.
 */
const QuestionnaireLocaleContext = React.createContext({
  locale: 'en',
  translations: {},
  chrome: (key) => chromeString({}, 'en', key),
  switcher: null,
});

export default QuestionnaireLocaleContext;
